import { useTheme } from '@emotion/react';
export default useTheme;
//# sourceMappingURL=useTheme.js.map